export const getOptionName = (options = [], value) =>
    options.find(o => o.id === value)?.name ?? value;